import { Component, OnInit } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { i18nPipe } from "../../helper/i18n.pipes";
import { DefaultLayoutComponent } from '../../component/common/default-layout/default-layout.component';

import { IFCAppServices } from "../../services/ifcapp.service";
import { BaseService } from '../../services/base.service';
import { BaseResponse, ICRewardsList } from '../../model/ifcapp.models';

import * as moment from 'moment';
import { StateService } from '../../services/state.service';
import { ExternalConnection } from "../../helper/externalConnection";

@Component({
  selector: 'app-reward-detail',
  templateUrl: './reward-detail.component.html',
  styleUrls: ['./reward-detail.component.scss']
})
export class RewardDetailComponent implements OnInit {

  isLoading = false;
  requestData;
  hash;
  redeemRequestData;
  redeemHash;
  debug = "Y";
  availablePoints:number = 0;
  language = 'en_US';
  reward;
  memberid:string = '1';
  rewardId:string = '0';
  memberPoints:number = 0;
  redeemLimit:number = 0;
  redeemQuantity:number = 1;
  requiredPoints:number = 0;
  displayPoints:number = 0;
  disabled = true;
  disabledConfirm = false;
  testing = false;
  decryptData = {};
  affiliated_card_id:string = "0";
  campaign_id:number = 0;
  appToken:string = "";
  platform:string = "IOS";
  deviceid:string = "";
  version:string = "";
  sessionkey:string = "";
  campaignId:string = "";
  fromWechat:boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute, 
    public state: StateService,
    private ifcAppServices: IFCAppServices, 
    private i18nPipe: i18nPipe, 
    private router: Router, 
    private layout: DefaultLayoutComponent,
    public _location: Location,

  ) {
    this.isLoading = true;
    this.activatedRoute.queryParams.subscribe((params) => {

      if (params['lang'] !== null && params['lang'] !== undefined ) {
        this.language = params['lang'];
        //lang (“zh_Hant” / “zh_Hans” / “en_US” , default en_US)
      }
      if (params['requestData'] !== null && params['requestData'] !== undefined ) {
        this.requestData = decodeURI(params['requestData']);
        console.log(this.requestData)
      }
      if (params['hash'] !== null && params['hash'] !== undefined ) {
        this.hash = params['hash'];
      }
      if (params['rewardId'] !== null && params['rewardId'] !== undefined ) {
        this.rewardId = params['rewardId'];
      }  
      if (params['testing'] !== null && params['testing'] !== undefined) {
        this.testing = params['testing'];
      }
      if (params['fromWechat'] !== null && params['fromWechat'] !== undefined) {
        this.fromWechat = JSON.parse(params['fromWechat']);
        console.log('reward-detail-fromWechat', this.fromWechat)
      }
    });
  }

  async ngOnInit() {
    if (this.testing) {
      this.requestData = 'agVcMmMZcR8nJLYy5nbBq9ASfukBMVzFZ5aOiDyVsHQfLFdT8Ni5XvzfRFcszlcg5YXB6HdZV2gCTOwM9iQr67N+uhquQxPaXdo2FgbTYtmdfiFXgoUejgKQivnIngIcrUyG/DEQdfc7KksrwSbBfG7glf2ZLGsPqC7C0L+N4Ymn+jEl2xkZ8vmHG8eecEDWOPfNrgCqGcFxaqlyg/w8xzsQ8+Ffp3BykUzpmmk0UHJH5qlp/YKkX0Bp9XI5uefQA9pcXgQYz4AU0q6wQkOSIODm2zEc6m32rJQ+MoRrzwna/MloS+9phbqTVOa44EIEIrf3X9crXdXS68kPt8xqIAf/Uk4l3ZY+isJ7pbUMd9wIlJumDb4CbBSEud4UClFU1grBzANzS6pYCpUQOI+5sA==';
      this.hash = "803762618c55d4a21b4d954f2b5fc8bd8a40d541";
    }

    console.log(this.requestData.replace(/\r?\n|\r/g,""))
    //{"current_time":"2021-08-02 12:33:02","lang":"en_US","member_id":100394,"affiliated_card_id":0,"app_token":"ks6Imnrexz3d6cLuOvrW9oh8HU1MD0LVKfXvc247","platform":"IOS","deviceid":"20F6A17C-A21E-4753-9D67-B127089B57B2","version":"4.3","sessionkey":"9ad575055bf74747b5e8f317acace35d","campaign_id":1}

    this.decryptData = JSON.parse(this.ifcAppServices.getICRewardDecryptData(this.requestData.replace(/\r?\n|\r/g,"")));
    console.log(this.decryptData);
    console.log(this.decryptData["member_id"]);
    this.memberid = this.decryptData["member_id"] ? this.decryptData["member_id"].toString() : this.memberid;
    this.appToken = this.decryptData["app_token"] ? this.decryptData["app_token"] : this.appToken;
    this.platform = this.decryptData["platform"] ? this.decryptData["platform"] : this.platform;
    this.sessionkey = this.decryptData["sessionkey"] ? this.decryptData["sessionkey"] : this.sessionkey;
    this.deviceid = this.decryptData["deviceid"] ? this.decryptData["deviceid"] : this.deviceid;
    this.affiliated_card_id = this.decryptData["affiliated_card_id"] ? this.decryptData["affiliated_card_id"].toString() : this.affiliated_card_id;

    let encryptedRequestObject = this.ifcAppServices.encryptICRewardData(JSON.stringify(this.decryptData));
    console.log(encryptedRequestObject);
    this.requestData = encryptedRequestObject;
    this.hash = this.ifcAppServices.hashICRewardData(JSON.stringify(this.decryptData));
    console.log(this.hash)
    console.log(this.memberid)
    // this.ifcAppServices.setIFCApiHeader(this.memberid);
    this.ifcAppServices.setIFCApiHeader(this.language, this.platform, this.memberid,this.affiliated_card_id, this.sessionkey, this.deviceid)

  
    let body = new FormData();
    body.append('request_data', this.requestData);
    body.append('hash', this.hash);
    body.append('debug', this.debug);

    let rewardListResponse = await this.ifcAppServices.getRewardList(body);
    let tmpRewardDetail;
    this.memberPoints = rewardListResponse.available_points;
    if (rewardListResponse.data != null) {
      tmpRewardDetail = rewardListResponse.data.find(x => x.rewardId === parseInt(this.rewardId));
    }
    console.log(tmpRewardDetail)
    console.log(this.language);
    if (this.language == 'zh_Hant') {
      tmpRewardDetail['reward_name'] = tmpRewardDetail['reward_name_tc']
      tmpRewardDetail['label_name'] = tmpRewardDetail['label_name_tc']
      tmpRewardDetail['details_image'] = tmpRewardDetail['details_image_tc']
      tmpRewardDetail['shop_url'] = tmpRewardDetail['shop_url_tc']
      tmpRewardDetail['shop_name'] = tmpRewardDetail['shop_name_tc']
      tmpRewardDetail['tnc_url'] = tmpRewardDetail['tnc_url_tc']
      tmpRewardDetail['tnc_name'] = tmpRewardDetail['tnc_name_tc']
      tmpRewardDetail['desc'] = tmpRewardDetail['desc_tc']
      tmpRewardDetail['participant_name'] = tmpRewardDetail['participant_name_tc']
      tmpRewardDetail['participant_url'] = tmpRewardDetail['participant_url_tc']
      tmpRewardDetail['others_name'] = tmpRewardDetail['others_name_tc']
      tmpRewardDetail['others_url'] = tmpRewardDetail['others_url_tc']
      tmpRewardDetail['valid_until'] = moment(tmpRewardDetail['valid_until']).locale('zh-HK').format('LL');
      tmpRewardDetail['redeem_period'] = moment(tmpRewardDetail['redeem_start_date']).locale('zh-HK').format("M月D日") + " - " + moment(tmpRewardDetail['redeem_end_date']).locale('zh_cn').format("M月D日");  
    } else if (this.language == 'zh_Hans') {
      tmpRewardDetail['reward_name'] = tmpRewardDetail['reward_name_sc']
      tmpRewardDetail['label_name'] = tmpRewardDetail['label_name_sc']
      tmpRewardDetail['details_image'] = tmpRewardDetail['details_image_sc']
      tmpRewardDetail['shop_url'] = tmpRewardDetail['shop_url_sc']
      tmpRewardDetail['shop_name'] = tmpRewardDetail['shop_name_sc']
      tmpRewardDetail['tnc_url'] = tmpRewardDetail['tnc_url_sc']
      tmpRewardDetail['tnc_name'] = tmpRewardDetail['tnc_name_sc']
      tmpRewardDetail['desc'] = tmpRewardDetail['desc_sc']
      tmpRewardDetail['participant_name'] = tmpRewardDetail['participant_name_sc']
      tmpRewardDetail['participant_url'] = tmpRewardDetail['participant_url_sc']
      tmpRewardDetail['others_name'] = tmpRewardDetail['others_name_sc']
      tmpRewardDetail['others_url'] = tmpRewardDetail['others_url_sc']
      tmpRewardDetail['valid_until'] = moment(tmpRewardDetail['valid_until']).locale('zh_cn').format('LL');
      tmpRewardDetail['redeem_period'] = moment(tmpRewardDetail['redeem_start_date']).locale('zh_cn').format("M月D日") + " - " + moment(tmpRewardDetail['redeem_end_date']).locale('zh_cn').format("M月D日");  
    } else {
      tmpRewardDetail['reward_name'] = tmpRewardDetail['reward_name_en']
      tmpRewardDetail['label_name'] = tmpRewardDetail['label_name_en']
      tmpRewardDetail['details_image'] = tmpRewardDetail['details_image_en']
      tmpRewardDetail['shop_url'] = tmpRewardDetail['shop_url_en']
      tmpRewardDetail['shop_name'] = tmpRewardDetail['shop_name_en']
      tmpRewardDetail['tnc_url'] = tmpRewardDetail['tnc_url_en']
      tmpRewardDetail['tnc_name'] = tmpRewardDetail['tnc_name_en']
      tmpRewardDetail['desc'] = tmpRewardDetail['desc_en']
      tmpRewardDetail['participant_name'] = tmpRewardDetail['participant_name_en']
      tmpRewardDetail['participant_url'] = tmpRewardDetail['participant_url_en']
      tmpRewardDetail['others_name'] = tmpRewardDetail['others_name_en']
      tmpRewardDetail['others_url'] = tmpRewardDetail['others_url_en']
      tmpRewardDetail['valid_until'] = moment(tmpRewardDetail['valid_until']).format("DD MMM YYYY");
      tmpRewardDetail['redeem_period'] = moment(tmpRewardDetail['redeem_start_date']).format("D MMM") + " - " + moment(tmpRewardDetail['redeem_end_date']).format("D MMM");  
    }
    // tmpRewardDetail['points'] = this.ifcAppServices.numberWithCommas(tmpRewardDetail['points'])
  //     "redeem_start_date": "2012-07-09",
  //     "redeem_end_date": "2021-12-31",
    console.log(tmpRewardDetail)

    this.reward = tmpRewardDetail;
    // this.reward = {campaignId: 1,
    //   crmCouponId: 67,
    //   crmGiftId: 826,
    //   desc: undefined,
    //   details_image: "https://s3-ap-southeast-1.amazonaws.com/ifc-dev-2018/tnc/648353bacf3a4adda18fc99f8f762913.png",
    //   details_image_en: "https://s3-ap-southeast-1.amazonaws.com/ifc-dev-2018/tnc/648353bacf3a4adda18fc99f8f762913.png",
    //   details_image_sc: "https://s3-ap-southeast-1.amazonaws.com/ifc-dev-2018/tnc/648353bacf3a4adda18fc99f8f762913.png",
    //   details_image_tc: "https://s3-ap-southeast-1.amazonaws.com/ifc-dev-2018/tnc/648353bacf3a4adda18fc99f8f762913.png",
    //   icon_image: "https://s3-ap-southeast-1.amazonaws.com/ifc-dev-2018/tnc/ba2f93732e804ffb86378a151e2a9b90.jpeg",
    //   label_name: undefined,
    //   limit: 1,
    //   low_stock: true,
    //   others_name: undefined,
    //   others_url: undefined,
    //   participant_name: undefined,
    //   participant_url: undefined,
    //   points: 500,
    //   redeem_end_date: "2021-09-09",
    //   redeem_period: "09 Aug - 09 Sep",
    //   redeem_start_date: "2021-08-09",
    //   rewardId: 8,
    //   reward_name: "ic Reward Conditional Voucher $400 en",
    //   reward_name_en: "ic Reward Conditional Voucher $400 en",
    //   reward_name_sc: "ic Reward Conditional Voucher $400 chs",
    //   reward_name_tc: "ic Reward Conditional Voucher $400 cht",
    //   reward_type: "coupon",
    //   seq_no: 5,
    //   shop_name: undefined,
    //   shop_url: undefined,
    //   stock: 1,
    //   tnc_name: undefined,
    //   tnc_url: undefined,
    //   valid_until: "31 Aug 2021",
    //   }
    this.displayPoints = this.ifcAppServices.numberWithCommas(tmpRewardDetail['points']);
    this.requiredPoints = parseInt(tmpRewardDetail['points']);

    this.checkAbleToRedeem();
    this.isLoading = false;
  }

  async checkAbleToRedeem() {
    // reward required points X redeem quantity <= member points
    //finialCheckLimit
    // = if limit = -1, check stock
    // = if limit > stock, check stock, 
    // = if limit <= stock, check limit,
    // redeem quantity < finalCheckLimit
    // this.memberPoints = 100;
    if (this.reward.limit == -1 || this.reward.limit > this.reward.stock) {
      this.redeemLimit = this.reward.stock;
    } else if (this.reward.limit <= this.reward.stock) {
      this.redeemLimit = this.reward.limit;
    }

    console.log(this.requiredPoints*this.redeemQuantity <= this.memberPoints);
    console.log(this.redeemQuantity <= this.redeemLimit);
    if (this.requiredPoints <= this.memberPoints && this.redeemQuantity <= this.redeemLimit) {
      console.log('haha')
      this.disabled = false;
    } else {
      this.disabled = true;
    }
    
  }

  async redeemReward() {
    if (this.disabled == false) {
      //prompt before submit alert
      this.layout.showAlert(
        this.i18nPipe.transform("Confirm to redeem with x,xxx ifc Points? ", '', this.language).replace("{points}", this.ifcAppServices.numberWithCommas(this.requiredPoints)),
        "<div>" + this.reward['reward_name'] + "</div>"
        + "<div>" + this.i18nPipe.transform("Quantity") + this.redeemQuantity + this.i18nPipe.transform("pc(s)") + "</div>"
        + '<br>' + this.i18nPipe.transform("Click \"Confirm\" to proceed.") 
        + '<br><br>' + this.i18nPipe.transform("The redemption cannot be cancelled or changed after confirmation."),
        this.i18nPipe.transform("Confirm"),
        () => {
          // this.layout.closeAlert();
          if (this.disabledConfirm == false) {
            this.disabledConfirm = true;
            //{"gift_id":"811","quantity":"1","reward_id":3,"lang":"zh_Hant","current_time":"2021-07-09 17:47:57","member_id":100875,"affiliated_card_id":"0","app_token":"NzluTJIpPexLaFvBxqpQdvSF2hWiUURpyrNWUc3n"}
            let requestObject = {
              "gift_id"  : this.reward["crmGiftId"],
              "quantity" : this.redeemQuantity,
              "reward_id" : this.rewardId,
              "lang" : this.language,
              "member_id" : this.memberid,
              "affiliated_card_id" : this.affiliated_card_id,
              "app_token" : this.appToken,
              "current_time": moment().format("YYYY-MM-DD HH:mm:ss")
            }
            let encryptedRequestObject = this.ifcAppServices.encryptICRewardData(JSON.stringify(requestObject));
            console.log(encryptedRequestObject);
            this.redeemRequestData = encryptedRequestObject;
            this.redeemHash = this.ifcAppServices.hashICRewardData(JSON.stringify(requestObject));
            console.log(this.hash)

            let body = new FormData();
            body.append('request_data', this.redeemRequestData);
            body.append('hash', this.redeemHash);
            body.append('debug', this.debug);
            this.ifcAppServices.redeemReward(body).then((response) => {
              this.layout.closeAlert();
              if (response.code == 0) {
                console.log('redeem success');
                this.promptSuccess();
              } else {
                console.log('Out of stock')
                this.failCallBackAlert();
              } 
              this.disabledConfirm = false;
            });
          }
        },
        this.i18nPipe.transform("Cancel"),
        () => {
          if (this.disabledConfirm == false) {
            this.layout.closeAlert()
          }
        },
        "bell"
      );
    }
    
  }

  promptSuccess() {

    const deepLinkKey = this.reward['reward_type'] == 'gift'? 'check_my_reward' : 'check_gift_voucher';
    const confirmButtonMessage = this.reward['reward_type'] == 'gift' ? 'Check Rewards' : 'Check Gift Voucher';
    const showConfirmBtn = this.fromWechat ? false : true;
    console.log('showConfirmBtn-----', showConfirmBtn)

    this.layout.showAlert(
      this.i18nPipe.transform("You have successfully redeemed:"),
      "<div>" + this.reward['reward_name'] + "</div>"
      + "<div>" + this.i18nPipe.transform("Quantity") + this.redeemQuantity + this.i18nPipe.transform("pc(s)") + "</div>",
      this.i18nPipe.transform(confirmButtonMessage),
      //callback
      () => {
        ExternalConnection.ReactNativeWebviewRedirect(deepLinkKey);
      },
      this.i18nPipe.transform("Done"),
      () => {
        this.backToRewardsList()
      },
      "tick",
      showConfirmBtn
    );
  }

  failCallBackAlert() {
    this.layout.showAlert(
      this.i18nPipe.transform("Sorry, something went wrong.", '', this.language),
      this.i18nPipe.transform("Please check your network settings and try again.", '', this.language),
      this.i18nPipe.transform("OK", '', this.language),
      this.layout.closeAlert(),
      "",
      null,
      null
    );
  
  }

  backToRewardsList() {
    this.layout.closeAlert();
    setTimeout(() => { 
      // this.router.navigate(['/icRewards/rewards-list'], { queryParams:{requestData: this.requestData, hash: this.hash, lang: this.language}});
      this._location.back();
    }, 200);
  }

  updateQuantity(action) {
    // console.log(action)
    if (action == "increase") {
      // this.redeemQuantity = (this.redeemQuantity < this.reward.stock) ? this.redeemQuantity + 1 : this.redeemQuantity;
      //Bug #4496 the QTY should be no limit when selection 20210725
      this.redeemQuantity = this.redeemQuantity + 1;
      this.requiredPoints = this.requiredPoints + parseInt(this.reward['points']);
    } else {
      this.requiredPoints = (this.redeemQuantity > 1) ? this.requiredPoints - parseInt(this.reward['points']) : this.requiredPoints;
      this.redeemQuantity = (this.redeemQuantity > 1) ? this.redeemQuantity - 1 : this.redeemQuantity;
    }
    console.log('redeemQuantity: ' + this.redeemQuantity);

    this.checkAbleToRedeem();
    //member points
    //limit: 5
    //stock: 100
    //points: "20"

  }
}

